export class Offcanvas {
  body: HTMLElement | null;
  menu: HTMLElement | null;
  button: HTMLElement | null;
  submenuButtons: NodeListOf<HTMLElement>;
  submenuBackButtons: NodeListOf<HTMLElement>;
  clickOutsideHandler: any;

  constructor() {
    this.body = document.querySelector('[data-offcanvas-body]');
    this.menu = document.querySelector('[data-offcanvas-menu]');
    this.button = document.querySelector('[data-offcanvas-button]');
    this.submenuButtons = document.querySelectorAll('[data-offcanvas-submenu-button]');
    this.submenuBackButtons = document.querySelectorAll('[data-offcanvas-submenu-back]');
    // this.link = document.querySelector('[data-offcanvas-link]'); // Link Farbe
    this.init();
  }

  init() {
    if (!this.body || !this.menu || !this.button) {
      return;
    }
    this.addTriggerEvents();
  }

  addTriggerEvents() {
    this.button!.addEventListener('click', () => {
      if (this.isOffcanvasVisible()) {
        this.closeOffcanvas();
      } else {
        this.openOffcanvas();
      }
    });
    this.submenuButtons.forEach((button) => {
      button.addEventListener('click', () => {
        let key = button.dataset.offcanvasSubmenuButton;
        this.openSubmenu(key);
      });
    });
    this.submenuBackButtons.forEach((button) => {
      button.addEventListener('click', () => {
        let key = button.dataset.offcanvasSubmenuBack;
        this.closeSubmenu(key);
      });
    });
    this.clickOutsideHandler = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.clickOutsideHandler, false);
    /*this.link.addEventListener('click', () => { //Link Farbe
      this.link.classList.add('currentLink');
    });*/
  }

  handleClickOutside(event) {
    let parents = document.querySelectorAll('[data-offcanvas-button],[data-offcanvas-menu]');
    let isInside = false;
    parents.forEach((element) => {
      if(element.contains(event.target) === true) {
        isInside = true;
      }
    });
    if(!isInside) {
      this.closeOffcanvas();
    }
  }

  openOffcanvas() {
    this.body?.classList.add('is-moved-right');
    this.menu?.classList.add('is-visible');
    document.body.classList.add('has-offcanvas-open');
  }

  closeOffcanvas() {
    this.body?.classList.remove('is-moved-right');
    this.menu?.classList.remove('is-visible');
    document.body.classList.remove('has-offcanvas-open');
  }

  isOffcanvasVisible(): boolean {
    return this.menu?.classList.contains('is-visible') ?? false;
  }

  openSubmenu(key) {
    let submenu = document.querySelector('[data-offcanvas-submenu="' + key + '"]');
    submenu?.classList.add('is-visible');
  }

  closeSubmenu(key) {
    let submenu = document.querySelector('[data-offcanvas-submenu="' + key + '"]');
    submenu?.classList.remove('is-visible');
  }

}

document.addEventListener("DOMContentLoaded", function() {
  new Offcanvas();
});
